module.exports = __webpack_public_path__ + "img/20210611165431.d9303f29.jpg";